import { useEffect } from 'react';
import { initializeDevCycleDebugger, } from './src/initializeDevCycleDebugger.js';
import { useDevCycleClient } from '@devcycle/react-client-sdk';
export const DevCycleDebugger = (options) => {
    const client = useDevCycleClient();
    useEffect(() => {
        const cleanupPromise = initializeDevCycleDebugger(client, options);
        return () => {
            cleanupPromise.then((cleanup) => cleanup());
        };
    }, [client]);
    return null;
};
//# sourceMappingURL=react.js.map